import React from 'react';
import { createRoot } from 'react-dom/client';
import LandingPage from './LandingPage';

declare global {
  interface Window {
    initTeamsLandingPageComp: () => void;
  }
}

const initTeamsLandingPage = (): void => {
  const domContainer = document.getElementById('react_landingPage');

  if (domContainer !== null) {
    createRoot(domContainer).render(
      <React.StrictMode>
        <LandingPage />
      </React.StrictMode>,
    );
  }
};

window.initTeamsLandingPageComp = initTeamsLandingPage;
